<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Organisationer</h1>
    <div class="comp-header__actions">
      <button mat-button [admRequiresFeatureRole]="roles['default-access-group.read']" [matMenuTriggerFor]="menu">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
        Standard adgangsgrupper
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="dialogService.openDefaultAccessGroupModal(OrganizationType.Business)">Erhverv</button>
        <button mat-menu-item (click)="dialogService.openDefaultAccessGroupModal(OrganizationType.HousingAssociation)">
          Boligforening
        </button>
        <button mat-menu-item (click)="dialogService.openDefaultAccessGroupModal(OrganizationType.Municipality)">Kommune</button>
      </mat-menu>

      <button mat-button (click)="dialogService.openDownloadReportDialog()" [admRequiresFeatureRole]="roles['invoice-report.download']">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#download-s"></use></svg>
        Download forbrugsrapport
      </button>

      <button
        type="button"
        [admRequiresFeatureRole]="roles['organization.write']"
        mat-raised-button
        color="primary"
        [routerLink]="['/organizations/wizard']">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
        <span>Opret organisation</span>
      </button>
    </div>
  </div>
  <div class="comp-header__deeplink-wrapper">
    @if (state.focusedOrganization()) {
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til&nbsp;
        <strong>Organisation : {{ state.focusedOrganization()?.name }}</strong>
        <button (click)="state.resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <div class="comp-header__queries">
        <adm-text-search #textSearch (search$)="searchInput($event)" [searchText]="state.filters().query ?? ''" />
      </div>
    }
  </div>
</div>
<div class="comp-main organizations">
  <ok-card [loading]="state.loading()">
    <ok-expand-list
      [trackBy]="'id'"
      [sort]="state.currentSort()"
      [data]="state.organizationsState().items"
      [itemTemplate]="org"
      [configuration]="config()"
      (sortChange)="state.onSortChange($event)">
    </ok-expand-list>
    <mat-paginator
      #paginator
      class="paginator"
      [pageSize]="state.filters().page.pageSize"
      [pageSizeOptions]="state.pagingOptions.pageSizeOptions"
      [pageIndex]="state.filters().page.pageIndex"
      [length]="state.organizationsState().totalCount"
      (page)="pageSwitch($event)"
      color="accent"
      [disabled]="state.loading()" />
  </ok-card>
</div>

<ng-template #org let-organization>
  <ok-card>
    <adm-organization-details
      [organization]="organization"
      (departmentDeleted)="departmentDeleted($event)"
      [highlightCreatedDepartmentId]="state.highlightDepartmentId" />
  </ok-card>
</ng-template>

<ng-template #idTagHeaderTemplate>
  <span class="icon">
    ID tag gruppe
    <span
      class="info-icon"
      matTooltip="Alle organisationens brikker vil være tilknyttet en ID tag gruppe. Det er denne gruppe som giver brikkerne adgang til at lade på organisationens lokationer."
      matTooltipPosition="below">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
    </span>
  </span>
</ng-template>

<ng-template #orgLogoColumn let-organization>
  <adm-organization-logo [organization]="organization" />
</ng-template>
